import { render, staticRenderFns } from "./ContractorQandA.vue?vue&type=template&id=48a63f16&scoped=true"
import script from "./ContractorQandA.vue?vue&type=script&lang=js"
export * from "./ContractorQandA.vue?vue&type=script&lang=js"
import style0 from "./ContractorQandA.vue?vue&type=style&index=0&id=48a63f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a63f16",
  null
  
)

export default component.exports